module.exports = __webpack_public_path__ + "img/music_icon.39f603bb.png";